import Types from "Types";
import { ActionType, createAction, getType } from "typesafe-actions";
import {
  DossierLocationCompositionLocationEnum,
  DossierParticulier,
} from "../../services/Api/swagger";
export interface SituationPersonnelleState {
  data?: Types.SituationPersonnelleData;
}

export const initialState: SituationPersonnelleState = {
  data: undefined,
};

export const updateSituationPersonnellePrincipal = createAction(
  "@@App/situationPersonnelle/UPDATE_PRINCIPAL_SUCCESS"
)<{
  situation: DossierParticulier;
}>();

export const updateSituationPersonnelleConjoint = createAction(
  "@@App/situationPersonnelle/UPDATE_CONJOINT_SUCCESS"
)<{
  situation: DossierParticulier;
}>();

export const resetSituationPersonnelleParcoursCreation = createAction(
  "@@App/situationPersonnelle/PARCOURS_CREATION/RESET_STORE"
)<void>();

export const removeSituationPersonnelleConjoint = createAction(
  "@@app/situationPersonnelle/REMOVE_CONJOINT"
)<void>();

export const resetSituationPersoAndAddGarant = createAction(
  "@@App/situationPersonnelle/PARCOURS_CREATION/RESET_AND_ADD_GARANT"
)<string>();

export const resetSituationPersoAndAddColoc = createAction(
  "@@App/situationPersonnelle/PARCOURS_CREATION/RESET_AND_ADD_COLOC"
)<string>();
export const resetSituationPersoAndAddLocataire = createAction(
  "@@App/situationPersonnelle/PARCOURS_CREATION/RESET_AND_ADD_LOCATAIRE"
)<string>();
export const ActionCreators = {
  updateSituationPersonnellePrincipal,
  updateSituationPersonnelleConjoint,
  resetSituationPersonnelleParcoursCreation,
  removeSituationPersonnelleConjoint,
  resetSituationPersoAndAddGarant,
  resetSituationPersoAndAddColoc,
  resetSituationPersoAndAddLocataire,
};

const getSituationPersonnelle = (
  state: Types.RootState
): Types.SituationPersonnelleData | undefined =>
  state.situationPersonnelle.data;

const getTypeCompte = (state: Types.RootState): string | undefined =>
  state.situationPersonnelle?.data?.situationPrincipale?.typeCompte;

const getRefLocataireGarant = (state: Types.RootState): string | undefined =>
  state.situationPersonnelle?.data?.situationPrincipale?.refDossierLocataire;

const getNomLocataire = (state: Types.RootState): string | undefined => {
  const data = state.situationPersonnelle?.data;
  if (data && data.situationConjoint && data.situationPrincipale) {
    return (
      data.situationPrincipale.prenom +
      " " +
      data.situationPrincipale.nom +
      " et " +
      data.situationConjoint.prenom +
      " " +
      data.situationConjoint.nom
    );
  }
  return (
    data?.situationPrincipale &&
    data.situationPrincipale.prenom + " " + data.situationPrincipale.nom
  );
};

const getCompositionLocation = (
  state: Types.RootState
): DossierLocationCompositionLocationEnum | undefined =>
  state.situationPersonnelle?.data?.situationPrincipale?.compositionLocation;
export const Selectors = {
  getSituationPersonnelle,
  getTypeCompte,
  getRefLocataireGarant,
  getNomLocataire,
  getCompositionLocation,
};

export const reducer = (
  state: SituationPersonnelleState = initialState,
  action: ActionType<typeof ActionCreators>
): SituationPersonnelleState => {
  switch (action.type) {
    case getType(updateSituationPersonnellePrincipal):
      return {
        data: {
          ...state.data,
          situationPrincipale: action.payload.situation,
        },
      };
    case getType(updateSituationPersonnelleConjoint):
      return {
        // @ts-ignore
        data: {
          ...state.data,
          situationConjoint: action.payload.situation,
        },
      };
    case getType(resetSituationPersonnelleParcoursCreation):
      return {
        ...state,
        data: {
          situationPrincipale: { principal: true },
          situationConjoint: undefined,
        } as Types.SituationPersonnelleData,
      };
    case getType(removeSituationPersonnelleConjoint):
      return {
        ...state,
        data: {
          ...state.data,
          situationConjoint: undefined,
        } as Types.SituationPersonnelleData,
      };
    case getType(resetSituationPersoAndAddGarant):
      return {
        ...state,
        data: {
          situationPrincipale: {
            principal: false,
            typeCompte: "GARANT",
            refDossierLocataire: action.payload,
          },
          situationConjoint: undefined,
        } as Types.SituationPersonnelleData,
      };

    case getType(resetSituationPersoAndAddColoc):
      return {
        ...state,
        data: {
          situationPrincipale: {
            principal: false,
            typeCompte: "LOCATAIRE",
          },
          situationConjoint: undefined,
        } as Types.SituationPersonnelleData,
      };
    case getType(resetSituationPersoAndAddLocataire):
      return {
        ...state,
        data: {
          situationPrincipale: {
            principal: true,
            typeCompte: "LOCATAIRE",
          },
          situationConjoint: undefined,
        } as Types.SituationPersonnelleData,
      };
    default:
      return state;
  }
};
